import { render, staticRenderFns } from "./deactivateDialog.vue?vue&type=template&id=7521fb49&scoped=true"
import script from "./deactivateDialog.vue?vue&type=script&lang=js"
export * from "./deactivateDialog.vue?vue&type=script&lang=js"
import style0 from "./deactivateDialog.vue?vue&type=style&index=0&id=7521fb49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521fb49",
  null
  
)

export default component.exports